/* tslint:disable:max-line-length */
import { type SegmentSpecificMessages } from "../../types/types";

export const lowIncomeMessages: SegmentSpecificMessages = {
  emailExplanation: "",
  addressExplanation: "Use your home address",
  step: {
    personalInfo: {
      title: "Unlock this Special Offer",
      subtitle: "Verify you qualify for an eligible government assistance program.",
      howDoesVerifyingWorkDetails:
        "To be eligible for this offer, you must currently qualify for an eligible government assistance program. The eligible Government Assistance Programs for this offer can be found in the box below." +
        "<br></br>" +
        "{companyName} uses SheerID, a trusted partner, to verify that you are a recipient of these benefits. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: "Check Your full name & other fields",
        subtitle: "Your information must match what is on your government-issued document(s).",
      },
      verifyingTitle: "Verifying your status",
      submitButtonText: "Verify my status",
    },
    docUpload: {
      uploadInstructions: "Upload an official document that shows",
      title:
        "To continue, upload documents that confirm your participation in an approved government assistance program",
      whoIsSheerId:
        "Document review is handled by SheerID, a trusted partner who specializes in verifying your eligibility.",
    },
    success: {
      title: "You've been verified",
      subtitle: "You are now eligible for this special offer.",
      redirectButtonText: "Continue",
    },
  },
};
